import img1 from '../../assets/img/img_product_detail/1.png'
import img2 from '../../assets/img/img_product_detail/2.png'
import img3 from '../../assets/img/img_product_detail/3.png'
import img4 from '../../assets/img/img_product_detail/4.png'
import img5 from '../../assets/img/img_product_detail/5.png'
import img6 from '../../assets/img/img_product_detail/6.png'

const listImg = [
    img1, img2, img3, img4, img5, img6
]

export default {
    listImg
}